import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import Datamap from 'datamaps';
import { geoEckert3 as geoCylindricalEqualArea } from 'd3-geo-projection';

import { MAP_COUNTRY_FILLS } from 'constants/countryProfile';
import { roundNumber } from 'utils/general';

class D3Map extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mapCountries: props.mapCountries || {}
    };
  }

  componentDidMount() {
    this.drawMap();
  }

  componentWillReceiveProps(newProps) {
    this.clear();
    this.setState({ mapCountries: newProps.mapCountries }, () => {
      this.drawMap();
    });
  }
  getDualSectorInfo(score, yearOfData) {
    return ` <div class="sector-info-wrapper">
                    <div class="sector-info">
                      <div class="score">Score
                        <span class="data">${score.mining && score.mining[`score${yearOfData}`] ? roundNumber(score.mining[`score${yearOfData}`]) : '–'}</span>
                        <span class="max"> /100</span>
                      </div>
                      <span class="legend sector-legend ">Mining</span>
                    </div>
                    <div class="sector-info" >
                    <div class="score">Score
                        <span class="data">${score['oil-gas'] && score['oil-gas'][`score${yearOfData}`] ? roundNumber(score['oil-gas'][`score${yearOfData}`]) : '–'}</span>
                        <span class="max"> /100</span>
                    </div>
                    <span class="legend sector-legend ">Oil & Gas</span>
                  </div>
                  <span class="legend bold year-legend">${yearOfData}</span>
                  </div>`;
  }
  getSingleSectorInfo(sector, score, yearOfData) {
    return ` <div class="sector-info-wrapper">
          <div class="sector-info">
            <div class="score">Score
              <span class="data">${score && score[`score${yearOfData}`] ? roundNumber(score[`score${yearOfData}`]) : '–'}</span>
              <span class="max">/100</span>
            </div>
            <span class="legend sector-legend">${sector}</span>
          </div>
             <span class="legend bold year-legend">${yearOfData}</span>
          </div>
    `;
  }

  clear() {
    const d3Map = this.refs.d3Map;
    for (const child of Array.from(d3Map.childNodes)) {
      child && d3Map.removeChild(child);
    }
  }

  drawMap() {
    // max rank is not the nu,ber of countries but the number of assesments.
    // I harcoded it because it is always 89. feel free to change it.
    // const maxRank = this.props.mapCountries ?
    //   Object.keys(this.props.mapCountries).length : 0;
    const options = {
      element: this.refs.d3Map,
      scope: 'countries',
      setProjection: () => {
        const projection = geoCylindricalEqualArea();
        if (window.innerWidth < 1030) projection.center([47, -3]).scale(150);

        const path = d3.geo.path().projection(projection);
        return { path, projection };
      },
      responsive: true,
      fills: MAP_COUNTRY_FILLS,
      geographyConfig: {
        dataUrl: '/api/geometries',
        hideAntarctica: true,
        borderColor: '#517188',
        borderWidth: 0.5,
        highlightOnHover: false,
        popupTemplate: (geography, data) => {
          if (!data) return null;
          const hasDualSector = data.score && (data.score.mining || data.score['oil-gas']);
          const el = d3.selectAll(`.${geography.id}`)[0];
          el && el[0].classList.add('-hover');

          if (hasDualSector) {
            return (
              `<div class="c-hoverinfo -dual-sector">
                <div class="header">
                  <p class="title -center">${data.name}</p>
                </div>
                <div class="content">
                ${data.allYears && data.allYears.map(year => this.getDualSectorInfo(data.score, year)).join('')}
                </div>
              </div>`);
          }

          return (
            `<div class="c-hoverinfo">
              <div class="header">
                <p class="title -center">${data.name}</p>
              </div>
              <div class="content">
              ${data.allYears && data.allYears.map(year => this.getSingleSectorInfo(data.sector, data.score, year)).join('')}
              </div>
            </div>`);
        }
      },
      data: this.state.mapCountries,
      done: (datamap) => {
        datamap.svg.selectAll('.datamaps-subunit').on('click', (geography) => {
          if (this.state.mapCountries[geography.properties.iso]) {
            const route = `/country-profiles/${geography.properties.iso}`;
            this.props.router.push(route);
          }
        });

        datamap.svg.selectAll('.datamaps-subunit').on('mouseout', () => {
          const els = d3.selectAll('.datamaps-subunit.-hover');
          const tooltip = d3.selectAll('.datamaps-hoverover')[0];

          els.forEach(el => {
            el && el.length && el[0].classList.remove('-hover');
          });

          if (tooltip && tooltip.length) {
            tooltip[0].innerHTML = '';
          }
        });
      }
    };

    const map = new Datamap(options);

    window.addEventListener('resize', () => {
      map.resize();
    });
  }

  render() {
    return (
      <div ref="d3Map" className="c-d3-map"></div>
    );
  }
}

D3Map.propTypes = {
  mapCountries: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired
};

export default withRouter(D3Map);



// WEBPACK FOOTER //
// ./app/components/common/map/index.jsx